import { ENDPOINT_API_NOTICE } from "AppConfig";

export const initNotification = `/${ENDPOINT_API_NOTICE}/device`;

export const getListNotificationURL = `/${ENDPOINT_API_NOTICE}/notice`;

export const updateNotificationStatusURL = `/${ENDPOINT_API_NOTICE}/notice`;
